import { Grid, Typography } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useFormContext } from "react-hook-form";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";

export const ItemRewarded: React.FC<any> = React.memo((props) => {
  const columns: IColumns[] = [
       
    {
      header: "Set QTY to Reward",
      fieldName: "",
      tooltip: true,
      type: "link",
    },
    {
      header: "QTY",
      fieldName: "",
      tooltip: true,
    },
    {
        header: "Item Name",
        fieldName: "",
        tooltip: true,
    },
    {
        header: "Transaction Type",
        fieldName: "",
        tooltip: true,
    },
   
  ];
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      <WSDataGrid
              id="itemrewardgrid"
              // title="Order Summary"
              columns={columns}
            /> 
      </Grid>
    </Grid>
  );
});
